import React, { useState, useRef, useEffect } from "react";
import { PlanMeta } from "../services/planService";
import "./PlanPicker.css";

interface PlanPickerProps {
  plans: PlanMeta[];
  activePlanId: string | null;
  onSelectPlan: (planId: string) => void;
  onCreatePlan: (title: string) => void;
  onRenamePlan: (planId: string, title: string) => void;
  onDeletePlan: (planId: string) => void;
  onJoinPlan: () => void;
}

const PlanPicker: React.FC<PlanPickerProps> = ({
  plans,
  activePlanId,
  onSelectPlan,
  onCreatePlan,
  onDeletePlan,
  onJoinPlan,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef<HTMLDivElement>(null);

  const activePlan = plans.find((p) => p.id === activePlanId);

  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target as Node)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="plan-picker" ref={wrapperRef}>
      <button className="plan-picker-trigger" onClick={() => setIsOpen(!isOpen)}>
        <span className="plan-picker-label">Plan:</span>
        <span className="plan-picker-value">{activePlan?.title || "Select Plan"}</span>
        <span className="plan-picker-chevron">▾</span>
      </button>
      {isOpen && (
        <div className="plan-picker-dropdown">
          {plans.map((plan) => (
            <button
              key={plan.id}
              className={`plan-picker-option ${plan.id === activePlanId ? "active" : ""}`}
              onClick={() => {
                onSelectPlan(plan.id);
                setIsOpen(false);
              }}
            >
              {plan.title}
            </button>
          ))}
          <button
            className="plan-picker-new"
            onClick={() => {
              onCreatePlan("");
              setIsOpen(false);
            }}
          >
            + New Plan
          </button>
          <button
            className="plan-picker-new plan-picker-join"
            onClick={() => {
              onJoinPlan();
              setIsOpen(false);
            }}
          >
            Join with Code
          </button>
        </div>
      )}
    </div>
  );
};

export default PlanPicker;
